import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

import moment from 'moment';

import { Report } from '~/components';
import { DateTime, Autocomplete, Input, RadioGroup } from '~/components/Form';
import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { isNull, isArray, concat, trim, isUndefined } from 'lodash';
import { GFO, GFU, GPP, GPPEM } from '~/constants/perfil';

import { toast } from 'react-toastify';
import * as Yup from 'yup';
import qs from 'querystring';
import api from '~/services/api';
import { parseDateString, t } from '~/helpers';

function Relabastecimentopartidafrio() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valueOrgao, setValueOrgao] = React.useState('');
  const [inputValueOrgao, setInputValueOrgao] = React.useState('');

  const [valueUnidade, setValueUnidade] = React.useState('');
  const [inputValueUnidade, setInputValueUnidade] = React.useState('');

  const [valuePosto, setValuePosto] = React.useState('');
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueBico, setValueBico] = React.useState('');
  const [inputValueBico, setInputValueBico] = React.useState('');

  const [multiPosto, setMultiPosto] = React.useState(false);

  const [organ, setOrgan] = useState({ orga_codigo: '', orga_nome: '' });
  const [organDisable, setOrganDisable] = useState(false)

  const [unity, setUnity] = useState({ unid_codigo: '', unid_nome: '' });
  const [unityDisable, setUnityDisable] = useState(false)

  const [beak, setBeak] = useState ({  bico_descricao: '', bico_numero: '' })

  const reportRef = useRef(null)

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);

  const [disableOrgao, setDisableOrgao] = useState(false);
  const [disablePosto, setDisablePosto] = useState(false);
  const [unidadeUsuario, setUnidadeUsuario] = useState(false);
  const [postoRequired, setPostoRequired] = useState(false);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        datahorainicial: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinal: Yup.date()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .transform((_, value) => parseDateString(value))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .max(
            datahorafinal,
            `A data não pode ser superior a ${datahorafinal}`
          )
          .min(
            Yup.ref('datahorainicial'),
            'A data não pode ser inferior a Data inicial'
          ),
        cond_cpf: Yup.string()
          .nullable()
          .max(11, t('s.geral.validacao.tamanhomaximo').replace('%s', 11)),
        veic_placa: Yup.string()
          .nullable()
          .max(7, t('s.geral.validacao.tamanhomaximo').replace('%s', 7)),
        poco_codigo: postoRequired
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .nullable()
          : Yup.string().nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });

      if (organDisable && unityDisable && !unity.unid_codigo) {
        throw ('Este usuário não possui unidade(s) cadastrada(s) !')
      }

    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      } else {
        throw err
      }
    }
  }

  const handleValidOrgaos = useCallback(async () => {

    try {

      const { data } = await api.get('orgaos');

      if (data.items.length == 1) {
        let tempOrgan = data.items[0]
        setOrgan(tempOrgan)
        setOrganDisable(true)

      } else if (data.items.length == 0) {
        setOrgan({ orga_codigo: '', orga_nome: '' })
        setOrganDisable(true)
      } else {
        setOrganDisable(false)
      }

    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }

  }, [])

  const handleValidUnidades = useCallback(async () => {

    try {
      const url = organDisable ? 'unidades/usuario' : 'unidades'
      const { data } = await api.get(url, {
        params: {
          wherefield: 'orga_codigo',
          valuewherefield: organ.orga_codigo,
          typewherefield: 'EQUALS',
          pagezie: 99999
        },
        paramsSerializer: (param) => qs.stringify(param)
      });

      if (data.items.length == 1) {
        const tempUnity = data.items[0]
        setUnity(tempUnity)
        setUnityDisable(true)

      } else if (data.items.length == 0) {
        setUnity({ unid_codigo: '', unid_nome: '' })
        setUnityDisable(true)
      } else {
        setUnityDisable(false)
      }

    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }

  }, [organ])
  const handleChangeUnity = useCallback((value) => {
    if (isNull(value.unid_nome)) setUnity({ unid_codigo: '', unid_nome: '' });
    else setUnity(value);
  }, []);

  const handleChangeOrgan = useCallback((value) => {
    if (isNull(value.orga_nome)) setOrgan({ orga_codigo: '', orga_nome: '' });
    else {
      setOrgan(value);
      setUnity({ unid_codigo: '', unid_nome: '' });
    }
  }, []);

  const handleChangeBeak = useCallback((value) => {
    if (isNull(value.bico_descricao)) setBeak({ bico_descricao: '', bico_numero: '' });
    else{
      setBeak(value);
    } 
  }, []);

  useEffect(() => {
    handleValidOrgaos()
  }, [])

  useEffect(() => {
    handleValidUnidades()
  }, [organ])


  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GFO || profile.glousuariotipo === GFU) {
        setValueOrgao(profile.glousuarioorgacodigo);
        setDisableOrgao(true);
      }
      if (profile.glousuariotipo === GFU) {
        setUnidadeUsuario(true);
      }
      if (profile.glousuariotipo === GPP) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      }
      if (profile.glousuariotipo === GPPEM) {
        setPostoRequired(true);
        setMultiPosto(true);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    const { datahorainicial, datahorafinal } = params;

    let orgao = '';

    if (params.orga_codigo) {
      orgao = params.orga_codigo;
    }

    let orgaostr = '';

    if (params.orga_nome) {
      orgaostr = params.orga_nome;
    }

    let unidade = '';

    if (params.unid_codigo) {
      unidade = params.unid_codigo;
    }

    let unidadestr = '';

    if (params.unid_nome) {
      unidadestr = params.unid_nome;
    }

    let placa = '';

    if (params.veic_placa) {
      placa = params.veic_placa;
    }

    let condutor = '';

    if (params.cond_cpf) {
      condutor = params.cond_cpf;
    }

    // deixa produto apenas para compor o filtro
    let produto = '';
    let produtostr = '';

    let tipo = 'pdf';

    if (params.formato) {
      tipo = params.formato;
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      posto: valuePosto ?? '',
      postostr: inputValuePosto ?? '',
      unidade: unity.unid_codigo ?? '',
      unidadestr: unity.unid_nome ?? '',
      orgao: organ.orga_codigo ?? '',
      orgaostr: organ.orga_nome ?? '',
      bico: beak.bico_numero ?? '',
      bicostr: beak.bico_descricao ?? '',
      bico_numero: beak.bico_numero ?? '',
      bico_descricao: beak.bico_descricao ?? '',
      produto,
      produtostr,
      placa,
      condutor,
      tipo,
    };
  }

  return (
    <Report
    ref={reportRef}
      open={open}
      onClose={() => setOpen(false)}
      title="Abastecimentos Partida a Frio"
      relatorio="ABASTECIMENTOSPARTIDAFRIO"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial,
        datahorafinal,
        poco_codigo: valuePosto,
      }}
    >
      <DateTime time label="Data Inicial" name="datahorainicial" />

      <DateTime time label="Data Final" name="datahorafinal" />

      <Autocomplete
        includeInputInList
        disabledItemsFocusable
        disableClearable={!organ.orga_nome}
        name="orgao"
        label="orga_nome"
        title="Órgão"
        url="orgaos"
        unique="orga_codigo"
        inputValue={organ.orga_nome}
        disabled={organDisable}
        getValue={handleChangeOrgan}
        onInputChange={(event, value) => {
          let obj = {
            ...organ,
            orga_nome: value,
          }
          setOrgan(obj);
        }}
      />

      <Autocomplete
        includeInputInList
        disabledItemsFocusable
        disableClearable={!unity.unid_codigo}
        name="unidade"
        label="unid_nome"
        title="Unidade"
        url="unidades"
        unique="unid_codigo"
        params={{
          wherefield: ['orga_codigo'],
          valuewherefield: [organ.orga_codigo],
          typewherefield: ['EQUALS'],
        }}
        disabled={isNull(organ.orga_codigo) || unityDisable}
        getValue={handleChangeUnity}
        inputValue={unity.unid_nome}
        onInputChange={(event, value) => {
          let obj = {
            ...unity,
            unid_nome: value,
          }
          setUnity(obj);
        }}
      />
      {multiPosto && (
        <Autocomplete
          name="poco_codigo"
          label="poco_desc_abrev"
          title="Posto"
          id="poco_codigo"
          url="postoscomboios/postosusuario"
          unique="poco_codigo"
          value={valuePosto}
          inputValue={inputValuePosto}
          onChange={(event, newValue) => {
            setValuePosto(newValue);
            setBeak({ bico_numero: '', bico_descricao: '' })
            reportRef.current.clearField('bico')
          }}
          onInputChange={(event, newInputValuePosto) => {
            setInputValuePosto(newInputValuePosto);
          }}
          defaultValue=""
          hiddens={[{ name: 'poco_desc_abrev' }]}
          getValue={(value) => {
            setBeak({ bico_numero: '', bico_descricao: '' })
            reportRef.current.clearField('bico')
            if (value.poco_codigo !== null) {
              setValuePosto(value.poco_codigo);
            } else {
              setValuePosto('');
            }
          }}
          disabled={disablePosto}
          required="true"
          params={{
            wherefield: 'usua_login',
            valuewherefield: profile.id,
            typewherefield: 'EQUALS',
          }}
        />
      )}

      {!multiPosto && (
        <Autocomplete
          name="poco_codigo"
          label="poco_desc_abrev"
          title="Posto"
          id="poco_codigo"
          url="postoscomboios"
          unique="poco_codigo"
          value={valuePosto}
          inputValue={inputValuePosto}
          onChange={(event, newValue) => {
            setValuePosto(newValue);
            setBeak({ bico_numero: '', bico_descricao: '' })
            reportRef.current.clearField('bico')
          }}
          onInputChange={(event, newInputValuePosto) => {
            setInputValuePosto(newInputValuePosto);
          }}
          defaultValue=""
          hiddens={[{ name: 'poco_desc_abrev' }]}
          getValue={(value) => {
            setBeak({ bico_numero: '', bico_descricao: '' })
            reportRef.current.clearField('bico')
            if (value.poco_codigo !== null) {
              setValuePosto(value.poco_codigo);
            } else {
              setValuePosto('');
            }
          }}
          disabled={disablePosto}
          required="true"
        />
      )}

      <Autocomplete
        includeInputInList
        disabledItemsFocusable
        disableClearable={!beak.bico_descricao}
        name="bico"
        label="bico_descricao"
        title="Bico"
        id="bico_numero"
        url="bicos"
        unique="bico_numero"
        params={{
          wherefield: ['poco_codigo'],
          valuewherefield: [valuePosto],
          typewherefield: ['EQUALS'],
        }}
        getValue={handleChangeBeak}
        inputValue={beak.bico_descricao}
        onInputChange={(event, value) => {
          if(valuePosto){
            let obj = {
              ...beak,
              bico_descricao: value,
            }
            setBeak(obj);
          }
          
        }}
      />
      <Input name="veic_placa" label="Placa" inputProps={{ maxLength: 7 }} />
      <Input name="cond_cpf" label="CPF Motorista" />
      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relabastecimentopartidafrio;
